import { Obj } from "@/types";

// Export query keys
export * from "./queryKeys";

// Common constants
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_STARTING_PAGE = 1;

// Default Values
export const DEFAULT_QUOTE_VALIDITY_DAYS = 30;
export const DEFAULT_DISCOUNT_PERCENTAGE = 0;
export const DEFAULT_CREDIT_LIMIT = 10000;

// Customer Type Values (matching Dataverse)
export const CUSTOMER_TYPE_TRADE_COUNTER = 1;
export const CUSTOMER_TYPE_INSTALLER = 2;

// Customer Type Options
export const CUSTOMER_TYPE_OPTIONS = [
  { label: "Trade Counter", value: 1 },
  { label: "Installer", value: 2 },
];

// Credit Terms Values (matching Dataverse)
export const CREDIT_TERMS_UPFRONT = 1;
export const CREDIT_TERMS_CREDIT = 2;

// Credit Terms Options
export const CREDIT_TERMS_OPTIONS = [
  { label: "Upfront Payment", value: 1 },
  { label: "Credit Account", value: 2 },
];

// Status Values
export const ONBOARDING_STATUS_ACTIVE = 1;
export const ONBOARDING_STATUS_INACTIVE = 0;

// Account Status Enum (statuscode values from Dataverse)
export enum AccountStatusEnum {
  ACCOUNT_CREATED = 1,
  SETUP_IN_PROGRESS = 736000001,
  SETUP_COMPLETE = 736000002,
}

// Sentinel value for deleted/inactive accounts (Dataverse statuscode=2)
export const ACCOUNT_DELETED_STATUSCODE = 2;

// Account Status Labels
export const ACCOUNT_STATUS_LABELS: Obj = {
  [AccountStatusEnum.ACCOUNT_CREATED]: "Account Created",
  [AccountStatusEnum.SETUP_IN_PROGRESS]: "Password Activated, Setup in Progress",
  [AccountStatusEnum.SETUP_COMPLETE]: "Setup Complete",
};

// Account Status Hex Colors (for stat cards)
export const ACCOUNT_STATUS_HEX_COLORS: Obj = {
  [AccountStatusEnum.ACCOUNT_CREATED]: "#1890ff", // blue
  [AccountStatusEnum.SETUP_IN_PROGRESS]: "#faad14", // orange
  [AccountStatusEnum.SETUP_COMPLETE]: "#52c41a", // green
};

// Account Status Options
export const ACCOUNT_STATUS_OPTIONS = [
  { label: "Account Created", value: AccountStatusEnum.ACCOUNT_CREATED },
  { label: "Password Activated, Setup in Progress", value: AccountStatusEnum.SETUP_IN_PROGRESS },
  { label: "Setup Complete", value: AccountStatusEnum.SETUP_COMPLETE },
  { label: "Deleted", value: ACCOUNT_DELETED_STATUSCODE },
];

// Regional Sales Managers
export const RSM_OPTIONS = [
  { value: "", label: "None" },
  { value: "James McGregor", label: "James McGregor (Scotland)" },
  { value: "Dylan Evans", label: "Dylan Evans (Wales)" },
  { value: "Connor O'Brien", label: "Connor O'Brien (Northern Ireland)" },
  { value: "Sophie Miller", label: "Sophie Miller (England North)" },
  { value: "Oliver Anderson", label: "Oliver Anderson (England South)" },
] as const;

// Support Contact
export const SUPPORT_CONTACT = {
  email: "support@victoriansliders.co.uk",
  phone: "+44 20 7946 0000",
} as const;

// Portal URLs
export const PORTAL_BASE_URL = "https://portal.victoriansliders.co.uk";

// Email Templates
export const EMAIL_SUBJECT = {
  WELCOME: "Welcome to Victorian Sliders CPQ Portal",
  REMINDER: "Complete Your Victorian Sliders Portal Setup",
} as const;

// Validation
export const VALIDATION_RULES = {
  MIN_DISCOUNT: 0,
  MAX_DISCOUNT: 100,
  MIN_QUOTE_VALIDITY: 1,
  MAX_QUOTE_VALIDITY: 365,
  MIN_CREDIT_LIMIT: 0,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;

// Modal content
export const CANCEL_MODAL_CONFIRMATION_CONTENT =
  "You have unsaved changes. Are you sure you want to cancel?";
